import fr from 'facet-rest';
import Tracker from '@openreplay/tracker';
import Dispatcher from '../Dispatcher';

const getOpenreplayConfig = () => {
  switch (process.env.REACT_APP_STAGE) {
    case 'prod':
      return {
        projectKey: 'QrVD8Z9TketRLYwvoiH6',
        ingestPoint: 'https://openreplay.prod.api.facetwealth.com/ingest',
        obscureTextEmails: true,
        obscureInputEmails: true,
        defaultInputMode: 2,
      };
    case 'staging':
      return {
        projectKey: '8FBoNSzNdGQXvVxdKwwr',
        ingestPoint: 'https://openreplay.dev.api.facet.com/ingest',
        obscureTextEmails: false,
        obscureInputEmails: false,
        obscureTextNumbers: false,
        defaultInputMode: 0,
        network: {
          capturePayload: true,
        },
      };
    case 'integration':
      return {
        projectKey: 'd6G5dpIBqd4Mwzrc8wwA',
        ingestPoint: 'https://openreplay.dev.api.facet.com/ingest',
        obscureTextEmails: false,
        obscureInputEmails: false,
        obscureTextNumbers: false,
        defaultInputMode: 0,
        network: {
          capturePayload: true,
        },
      };
    case 'development':
    default:
      return null; // Uncomment below and remove this line to enable openreplay locally, then watch your sessions at https://openreplay.dev.api.facet.com/4/
      // return {
      //   projectKey: '8FBoNSzNdGQXvVxdKwwr',
      //   ingestPoint: 'https://openreplay.dev.api.facet.com/ingest',
      //   obscureTextEmails: false,
      //   obscureInputEmails: false,
      //   obscureTextNumbers: false,
      //   defaultInputMode: 0,
      //   __DISABLE_SECURE_MODE: true,
      //   network: {
      //     capturePayload: true,
      //   },
      // };
  }
};
const enablementFilter = {
  isDisabled: !getOpenreplayConfig(),
};

Dispatcher.registerInit(enablementFilter, () => {
  const {
    projectKey, __DISABLE_SECURE_MODE, ingestPoint, obscureTextEmails, obscureInputEmails, obscureTextNumbers, defaultInputMode,
  } = getOpenreplayConfig();
  window.tracker = new Tracker({
    __DISABLE_SECURE_MODE,
    projectKey,
    ingestPoint,
    obscureTextEmails,
    obscureInputEmails,
    obscureTextNumbers,
    defaultInputMode,
  });
  tracker.start();

  fr.config.addRequestInterceptor((req) => {
    req.opts.headers['X-Open-Replay-Session-Id'] = tracker.getSessionID();
    req.opts.headers['X-Open-Replay-Session-Url'] = tracker.getSessionURL();
    return req;
  });

  Dispatcher.registerIdentify(enablementFilter, ({ userId, visitorSessionUUID }) => {
    if (userId) {
      tracker.setUserID(userId);
      return;
    }
    if (visitorSessionUUID) {
      tracker.setUserID(`vs-${visitorSessionUUID}`);
    }
  });
});
